import type { ErrorResponse } from '@shared/types/http'

import { endpoint } from '@shared/services/endpoint'
import useSWR from 'swr'

import type { Response } from '../types/common'
import type { Product } from '../types/product'
import type { Config } from '../types/shop'

import { getRequest } from '../../../shared/services/fetcher'
import { createURLParams } from '../utils'

export type ShopConfigRequest = {
  parentSlug?: string
}

export const useShopConfig = (request?: ShopConfigRequest) => {
  const params = createURLParams(request || {})
  return useSWR<Config, ErrorResponse>(
    `${endpoint.frontend.SHOP.CONFIG}?${params.toString()}`,
    getRequest,
  )
}

export const useShopGetRecentlyViewedProducts = () => {
  return useSWR<Response<Product[]>, Error>(
    endpoint.frontend.SHOP.RECENTLY_VIEWED_PRODUCTS,
    getRequest,
  )
}
